import type { SVGProps } from 'react';

export const Play = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.334 11.4436C16.4451 10.8021 16.4451 9.19838 15.334 8.55688L7.83398 4.22675C6.72287 3.58525 5.33398 4.38713 5.33398 5.67013V14.3304C5.33398 15.6134 6.72287 16.4153 7.83399 15.7738L15.334 11.4436Z"
      fill="white"
    />
  </svg>
);
